import script from "./new-content.vue?vue&type=script&setup=true&lang=js"
export * from "./new-content.vue?vue&type=script&setup=true&lang=js"

import "./new-content.vue?vue&type=style&index=0&id=29d10b6e&lang=less&scoped=true"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d10b6e"]])

export default __exports__